module.exports = __webpack_public_path__ + "img/error-token-ngen.21fdcc5c.svg";